import React from "react";
import { useApp } from "@/context/AppContext";
import { useSEO } from "@/lib/seo";
import { Breadcrumbs } from "@/components/common/states";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    path: "/privacy-policy",
    body: [
      ["Overview", "This Privacy Policy explains how Endeavour Castle collects and uses information when you use this website. We collect information you voluntarily provide through enquiry, requirement, contact and site-visit forms."],
      ["Information We Collect", "We may collect your name, phone number, email address, property preferences and the message you submit. We also collect basic technical and marketing attribution data such as the page you landed on, referrer and UTM campaign parameters where available."],
      ["How We Use It", "We use your information solely to respond to your enquiry, share relevant property options and improve our services. We do not sell your personal information."],
      ["Data Retention", "We retain enquiry information for as long as necessary to assist you and to comply with applicable requirements."],
      ["Your Choices", "You may request access to or deletion of your information by contacting us using the details on our Contact page."],
      ["Contact", "For any privacy-related questions, please reach out via the Contact page."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    path: "/terms",
    body: [
      ["Acceptance", "By accessing this website you agree to these Terms & Conditions. If you do not agree, please do not use the website."],
      ["Nature of Information", "Content on this website, including demo listings, is provided for general information. Property details, pricing, availability and RERA information are indicative and confirmed only on enquiry."],
      ["No Offer", "Nothing on this website constitutes a legal offer, invitation to offer, or investment advice. Users should independently verify all information before making any decision."],
      ["Intellectual Property", "All trademarks, content and design elements are the property of their respective owners and may not be reproduced without permission."],
      ["Limitation of Liability", "To the extent permitted by law, Endeavour Castle is not liable for any loss arising from reliance on information presented here."],
      ["Governing Law", "These terms are governed by the laws of India, with jurisdiction in Pune, Maharashtra."],
    ],
  },
  rera: {
    title: "RERA Disclaimer",
    path: "/rera-disclaimer",
    body: [
      ["Disclaimer", "Endeavour Castle operates as a property discovery and advisory service. Project and property information on this website, including demo records created during development, is indicative and subject to change."],
      ["RERA Registration", "RERA registration numbers, approved plans, carpet areas and other statutory details are shared on enquiry for each project. We do not publish or fabricate RERA numbers."],
      ["Buyer Responsibility", "Prospective buyers are advised to verify all project details, approvals and RERA registration on the official Maharashtra RERA (MahaRERA) portal before making any purchase decision."],
      ["No Guarantee", "We make no representation or warranty regarding returns, appreciation or guaranteed outcomes of any property."],
    ],
  },
};

export default function Legal({ type }) {
  const { settings } = useApp();
  const c = CONTENT[type];
  useSEO({ title: c.title, description: `${c.title} for Endeavour Castle Pune.`, path: c.path });

  return (
    <div className="ec-container py-8 sm:py-12 max-w-3xl">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: c.title }]} />
      <h1 className="font-display text-3xl sm:text-4xl text-foreground mt-4 mb-2">{c.title}</h1>
      <p className="text-sm text-muted-foreground mb-8">Last updated {new Date().getFullYear()}</p>
      {type === "rera" && settings?.rera_disclaimer && (
        <p className="p-5 rounded-md border border-accent/40 bg-accent/5 text-sm text-foreground/80 mb-8">{settings.rera_disclaimer}</p>
      )}
      <div className="space-y-8">
        {c.body.map(([h, p]) => (
          <section key={h}>
            <h2 className="font-display text-xl text-foreground mb-2">{h}</h2>
            <p className="text-muted-foreground leading-relaxed">{p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
